import { Controller } from "@hotwired/stimulus"

// Debounced auto-submit for the search field: each keystroke resets a short timer, and
// when it settles the toolbar form submits (a Turbo-Frame GET), so the list filters live
// without a page reload. Attached to the <form>; the search input triggers submit().
//
// A form may also name one value worth confirming before it is sent — the permissions grid uses
// it for the one choice that takes access away. window.confirm rather than data-turbo-confirm
// because declining has to put the control back before anything submits: Turbo's cancel path
// would leave the select showing a value the server never accepted, which on that screen is
// exactly the lie the control exists to prevent. Nothing sets Turbo.setConfirmMethod, so this is
// the same native dialog every other confirm in the app already shows.
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 250 },
    confirmOn: String,
    confirmText: String
  }

  submit(event) {
    const control = event?.target

    if (this.needsConfirm(control) && !window.confirm(this.confirmTextValue)) {
      this.revert(control)
      return
    }

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  needsConfirm(control) {
    return this.hasConfirmOnValue && control?.value === this.confirmOnValue
  }

  // The server-rendered `selected` option is the true current state, and defaultSelected still
  // reflects it after the user has moved .value — so declining restores it with no bookkeeping.
  revert(select) {
    const original = Array.from(select?.options || []).find((option) => option.defaultSelected)

    if (original) select.value = original.value
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
